import { z } from 'zod'

/**
 * Schema for upserting user wage information
 */
export const UpsertUserWageSchema = z.object({
  userGuid: z.string().uuid(),
  hourlyWageUsc: z.number().int().nonnegative(),
  fullyBurdenedHourlyWageUsc: z.number().int().nonnegative(),
  wageDateStart: z.string(), // ISO date
  wageDateEnd: z.string().nullable().optional(),
})
export type UpsertUserWageInput = z.infer<typeof UpsertUserWageSchema>

/**
 * Schema for user wage response
 */
export const UserWageSchema = z.object({
  userWageGuid: z.string().uuid(),
  userGuid: z.string().uuid(),
  companyGuid: z.string().uuid(),
  hourlyWageUsc: z.number().int().nonnegative(),
  fullyBurdenedHourlyWageUsc: z.number().int().nonnegative(),
  wageDateStart: z.string(),
  wageDateEnd: z.string().nullable(),
  createdByUserGuid: z.string().uuid(),
  createdAt: z.string(),
})
export type UserWageResponse = z.infer<typeof UserWageSchema>
